import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FakeCounter from '../components/FakeCounter';
import { useGame } from '../context/GameContext';

const Landing: React.FC = () => {
  const navigate = useNavigate();
  const { setPhase } = useGame();
  const { t } = useTranslation('landing');

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 py-10 relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #00082f 0%, #001055 60%, #00082f 100%)',
      }}
    >
      {/* Background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 w-full max-w-sm flex flex-col items-center text-center gap-6">
        {/* Header */}
        <div className="flex flex-col items-center gap-2">
          <img src="/assets/logo.png" alt="Zepo" className="h-10 object-contain" />
          <span className="text-blue-300 text-sm font-medium tracking-widest uppercase">
            {t('brand')}
          </span>
        </div>

        {/* Hero text */}
        <div>
          <h1 className="text-3xl font-bold text-white leading-tight mb-3">
            {t('hero.title')}
          </h1>
          <p className="text-blue-200 text-lg">
            {t('hero.subtitle')}
          </p>
        </div>

        {/* iPhone incentive */}
        <div className="glass-card p-6 w-full">
          <img src="/assets/mobiles.svg" alt="iPhone 17 Pro" className="h-28 object-contain mx-auto mb-4 drop-shadow-[0_0_25px_rgba(59,130,246,0.3)]" />
          <h2 className="text-white font-bold text-xl mb-2">
            {t('incentive.title')}
          </h2>
          <p className="text-blue-200 text-base">
            {t('incentive.subtitle')}{' '}
            <strong className="text-white">{t('incentive.prize')}</strong>
          </p>
          <div className="mt-4 flex items-center justify-center gap-2 text-white/60 text-sm">
            <span>⚡</span>
            <span>{t('incentive.detail')}</span>
          </div>
        </div>

        {/* Fake counter */}
        <FakeCounter />

        {/* Pulsing badge */}
        <div className="flex items-center gap-2 bg-orange-500/20 border border-orange-500/40 rounded-full px-4 py-2">
          <span className="inline-block w-2 h-2 rounded-full bg-orange-400 animate-pulse" />
          <span className="text-orange-300 text-sm font-medium">{t('badge')}</span>
        </div>

        {/* CTA */}
        <button
          onClick={() => { setPhase('registration'); navigate('/registro'); }}
          className="w-full bg-blue-600 hover:bg-blue-500 active:bg-blue-700 text-white font-bold text-lg rounded-2xl px-8 min-h-[56px] py-4 transition-all active:scale-[0.98] shadow-lg shadow-blue-600/30"
        >
          {t('cta')}
        </button>

        <p className="text-white/30 text-xs">
          {t('footer')}
        </p>
      </div>
    </div>
  );
};

export default Landing;
